import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { lang_consulta } from 'app/idiomas/i18n/consult-survey/consult.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ConsultaEncuestaService } from "./consulta-encuesta.service";
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import {TranslateService} from '@ngx-translate/core';
import * as backInter from 'app/auth/auth-data.model';
const moment = require('moment');
const momentTz = require('moment-timezone');
import { DatePipe } from '@angular/common';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-consulta-encuesta',
  templateUrl: './consulta-encuesta.component.html',
  styleUrls: ['./consulta-encuesta.component.scss'],
  animations   : fuseAnimations
})
export class ConsultaEncuestaComponent implements OnInit {

  anchoListas: number;
  anio: number;
  broker: number;
  brokerCountry: string;
  anioRanking: number;
  idiomaActual: string;

  campos = [
    {
      clave: 'anio',
      icono: 'calendar_today',
      activo: true,
      catalogo: [
        { anio: '2020' },
        { anio: '2021' },
        { anio: '2022' },
        { anio: '2023' },
        { anio: '2024' },
        { anio: '2025' },
        { anio: '2026' },
        { anio: '2027' }
      ]
    },
    {
      clave: 'anioRanking',
      icono: 'calendar_today',
      activo: true,
      catalogo: [
        { anio: '2020' },
        { anio: '2021' },
        { anio: '2022' },
      ]
    },
    {
      clave: 'broker',
      icono: 'flag',
      funcion: 'eligeBroker',
      activo: true
    },
    {
      clave: 'brokerCountry',
      icono: 'public',
      activo: true
    },
  ];

  busquedaIniciada: boolean;
  buscando: boolean;

  datosEncuestas: any;
  years : any;
  offsetPipe: string;
  indiceZona: number;
  diferenciaUtc: number;
  zonasUTC = zonasUTC;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private servicio: ConsultaEncuestaService,
    private odsService: ODSService,
    private translateSrv: TranslateService,
    private datePipe: DatePipe,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    lang_consulta.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {
    this.getInstitutos();
    this.getYears();
    const instituto = localStorage.getItem('instituto_id');
    if (instituto!='0') {
      this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(instituto));
      this.calculoOffsetPipe();
    }else{}
    if(instituto != '0'){ //si el instituto no es 0 (usuario itbm) se oculta la lista del broker
      let objBroker: any = this.campos.find(item => item.clave == 'broker');
      objBroker.activo = false;
      this.broker = parseInt(instituto);
      this.eligeBroker();
      this.anchoListas = 45;
    } else{
      this.anchoListas = 30;
    }
  }

  private getYears() {
    this.odsService.getYearsArray().subscribe((response: any) => {
      console.log("años asignados::::::",response);
      this.years = response.anios;
      this.campos[1].catalogo=this.years;
    }, error => {
      console.log("error", error);
    });
  }

  getInstitutos(){
    this.servicio.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      if(respuesta.success){
        let arregloBrokers = [];
        respuesta.Institutos.forEach(broker => {
          arregloBrokers.push({
            numInstituto: broker.numInstituto,
            anio: broker.numInstituto,
            traducible: true
          });
        });
        console.log("this.campos.",this.campos);

        let objBroker: any = this.campos.find(item => item.clave == 'broker');
        objBroker.catalogo = arregloBrokers;
      }
    });
  }

  eligeBroker(){
    console.log("brokerelegido:",this.broker);
    this.brokerCountry = undefined;
    this.servicio.getPaisesBroker(this.broker.toString()).subscribe((respuesta:any) => {
      console.log("getPaisesBroker:",respuesta);
      if(respuesta.success){
        let arregloPaises = [];
        if(respuesta.result){
          respuesta.result.forEach(pais => {
            arregloPaises.push({
              countryName: pais.CountryName.trim(),
              anio: pais.CountryName.trim()
            });
          });
        } else{
          arregloPaises.push({
            countryName: 'sinPaises',
            anio: 'sinPaises',
            traducible: true
          });
        }
        let objBroker: any = this.campos.find(item => item.clave == 'brokerCountry');
        objBroker.catalogo = arregloPaises;

        this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.broker);
        this.calculoOffsetPipe();
      }
    });
  }

  getDatosEncuestas(){
    if(this.anio != undefined && this.anioRanking != undefined && this.broker != undefined && this.brokerCountry != undefined ){
      this.busquedaIniciada = true;
      this.buscando = true;
      this.datosEncuestas = undefined;
      this.servicio.getDatosEncuestas(this.anio, this.broker, this.brokerCountry,this.anioRanking,this.idiomaActual).subscribe((respuesta:any) => {
        console.log("getDatosEncuestas:",respuesta);
        if(respuesta.success){
          this.datosEncuestas = respuesta.data;
        }
        this.buscando = false;
      });
    } else{
      console.log("aun no listo");

    }
  }

  descargarResultados(){
    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: 'Encuestas',
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    for (let clave in this.datosEncuestas[0]) {
      nombresColumnas.push(clave);
    }
    ws_data.push(nombresColumnas);
    this.datosEncuestas.forEach( (info) => {
      let datosEncuestas:any[] = [];
      // info['Survey Start']=this.datePipe.transform(new Date(info['Survey Start']),'d MMM y H:mm',this.offsetPipe,this.idiomaActual);
      info['Survey End']=this.datePipe.transform(new Date(info['Survey End']),'d MMM y H:mm',this.offsetPipe,this.idiomaActual);
      console.log(info);
      nombresColumnas.forEach( (nombre) => {
        // console.log(info[nombre]);
            datosEncuestas.push(info[nombre]);

      });
      console.log('datosEncuestas',datosEncuestas);

      ws_data.push(datosEncuestas);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'Reporte consultar encuestas'}.xlsx`);
    // Swal.close();
  }

  calculoOffsetPipe(diff?:any){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = diff!=undefined?diff/60:this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

}
